import FirebaseContext, { withFirebase } from './Context';
import Firebase from './Firebase';

const FIREBASE_API_URL =
  process.env.REACT_APP_FIREBASE_FUNCTIONS_URL ||
  'http://localhost:5001/mywhanau-admin/australia-southeast1';
export default Firebase;

export { FirebaseContext, withFirebase, FIREBASE_API_URL };
